import { StoryblokImage } from '@/components/customFields/StoryblokImage';
import { linkToString } from '@/helper/urls';
import type { MultiassetStoryblok } from '@/types/component-types-sb';
import { ColumnWidth } from '@/types/layoutTypes';
import Link from 'next/link';
import { type FC } from 'react';

import classes from './Badges.module.scss';

const Badges: FC<{ badges: MultiassetStoryblok; href: string }> = ({ badges, href }) => {
  return (
    <div className={classes.Badges}>
      {badges.map((asset) => (
        <figure key={asset.id}>
          <Link href={linkToString(href)}>
            <StoryblokImage
              image={asset}
              width={{
                columnsMobile: ColumnWidth.FULL,
                columnsTablet: ColumnWidth.HALF,
                columnsDesktop: ColumnWidth.ONE_QUARTER,
              }}
            />
          </Link>
        </figure>
      ))}
    </div>
  );
};

export default Badges;
